import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConnectionService } from '../../../services/connection/connection.service';
import { Schedule } from '../models/schedule';


@Injectable()
export class ScheduleOdooService {

  constructor(private connectionService: ConnectionService) { }

  getAllSchedulesInfo(): Observable<Schedule[]> {
    return this.connectionService.sendJsonPostRequest('/store/area/all_schedules_info', {})
      .pipe(map(
        (result) => {
          const schedulesInfos = result ? result.map(x => Schedule.createFromAny(x)).sort((n1, n2) => n1.sequence - n2.sequence) : [];
          return schedulesInfos;
        }));
  }
}
